import React from 'react';
import { LinearProgress } from "@mui/material";

const Loading = () => {
    return (
      <>
        <br />
        <LinearProgress />
      </>
    );
  };

  export default Loading;